import type { InternalNetworkAttackPathEventDto } from '@terra/shared-contracts-internal-network';
import { isMilestoneInfraImpact } from '@terra/shared-schemas-orchestrator';

export const dropAttackPathNonMilestoneImpacts = (
  events: InternalNetworkAttackPathEventDto[],
): InternalNetworkAttackPathEventDto[] =>
  events.filter((event) => {
    if (event.kind !== 'IMPACT_ACHIEVED') {
      return true;
    }

    return isMilestoneInfraImpact(event.infraImpact);
  });
